import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import putOmeMeetOrgUnitEntryTimesData from './PutOmeMeetOrgUnitEntryTimesData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OmeMeetOrgUnitEntryTimesData = {
  INITIAL_STATE, putOmeMeetOrgUnitEntryTimesData
};

export default OmeMeetOrgUnitEntryTimesData;